import { createAsyncActionTypes } from '@mews/framework';
import { prefix } from './module';

export const ENTERPRISE_RATE_MANAGEMENT_INIT = prefix('ENTERPRISE_RATE_MANAGEMENT_INIT');
export const [
    ENTERPRISE_RATE_MANAGEMENT_INIT_STARTED,
    ENTERPRISE_RATE_MANAGEMENT_INIT_SUCCEEDED,
    ENTERPRISE_RATE_MANAGEMENT_INIT_FAILED,
] = createAsyncActionTypes(ENTERPRISE_RATE_MANAGEMENT_INIT);

export const FETCH_FLAG_SET = prefix('FETCH_FLAG_SET');
export const DATA_TO_FETCH_SET = prefix('DATA_TO_FETCH_SET');
